import classNames from 'classnames';
import * as React from 'react';
import AnimateHeight from '../../../../Utils/AnimateHeight';
import './style.css';

export interface PaymentErrorsProps {
  className?: string;
  errors: string[];
}

export interface PaymentErrorsState {
  /* empty */
}

export class PaymentErrors extends React.Component<
  PaymentErrorsProps,
  PaymentErrorsState
> {
  render() {
    const { className, errors } = this.props;

    return (
      <AnimateHeight
        className={classNames('payment-errors', className)}
        height={errors.length ? 'auto' : 0}
      >
        <ul className="payment-errors__errors-list">
          {errors.map(error => (
            <li className="payment-errors__error-message" key={error}>
              {error}
            </li>
          ))}
        </ul>
      </AnimateHeight>
    );
  }
}

export default PaymentErrors;



// WEBPACK FOOTER //
// ./src/app/components/Premium/Checkout/PaymentForm/PaymentErrors/index.tsx